import React, { useEffect, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import {
  isAgencyAdmin,
  isRolePlatformAdmin,
} from "../../../modules/permissions";
import { token, userAgencyObject } from "../../../modules/auth";
import AgencyFeaturesForm from "./AgencyFeaturesForm";
import {
  editAgencyFeatures,
  fetchAgenciesForSelect,
  fetchAgencyFeatures,
} from "../../../redux/actions";
import Loading from "../../Loading";
import { Succeeded } from "../../Form";
import * as ROUTES from "../../../Router/corporate_routes";

function AgencyFeatures({
  agency,
  token,
  fetchAgenciesForSelect,
  fetchAgencyFeatures,
  isFetchingAgencies,
  isFetchingAgencyFeatures,
  editAgencyFeatures,
}) {
  const [success, setSuccess] = useState(false);
  const [parentFeatures, setParentFeatures] = useState(null);
  const [
    isFetchingParentAgencyFeatures,
    setIsFetchingParentAgencyFeatures,
  ] = useState(false);

  useEffect(() => {
    if (agency && agency.id) {
      fetchAgenciesForSelect(token, agency.id);
      fetchAgencyFeatures(token, agency.id);
      if (agency.is_managed_by_parent_agency && agency.parent_agency_id) {
        setIsFetchingParentAgencyFeatures(true);
        axios
          .get(
            window.API +
              ROUTES.API.AGENCY.FEATURES.SINGLE.replace(
                ":agencyId",
                agency.parent_agency_id
              ),
            { headers: { Authorization: `Bearer ${token}` } }
          )
          .then(res => setParentFeatures(res.data?.data))
          .catch(err =>
            console.error("Parent agency features fetch error:", err)
          )
          .finally(() => setIsFetchingParentAgencyFeatures(false));
      }
    }
  }, [agency]);

  const onSubmit = formValues => {
    const formData = new FormData();
    formData.append("_method", "PATCH");
    Object.entries(formValues).forEach(([key, value]) => {
      if (value !== undefined) {
        if (value === true || value === false) {
          value = value ? 1 : 0;
        }

        if (key === "child_agencies" && Array.isArray(value)) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      }
    });
    formData.delete("childAgencies");
    formData.delete("id");
    editAgencyFeatures(agency.id, formData, token).then(() => {
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 2500);
    });
  };

  if (
    !agency ||
    (agency && Object.keys(agency).length === 0) ||
    isFetchingAgencies ||
    isFetchingAgencyFeatures ||
    isFetchingParentAgencyFeatures
  ) {
    return <Loading />;
  }

  return (
    <>
      <div className={"row"}>
        <div className={"col col-w-full"}>
          <h3 className="uppercase pt-5 border-t border-grey my-5">Features</h3>
          <AgencyFeaturesForm
            agency={agency}
            onSubmit={onSubmit}
            parentFeatures={parentFeatures}
          />
          {success ? <Succeeded /> : null}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = state => {
  return {
    ...state,
    ...state.agency,
    token: token(state),
    isRolePlatformAdmin: isRolePlatformAdmin(state.auth),
    userAgency: userAgencyObject(state),
    isAgencyAdmin: isAgencyAdmin(state.auth),
  };
};

const mapDispatchToProps = {
  fetchAgenciesForSelect,
  fetchAgencyFeatures,
  editAgencyFeatures,
};

export default connect(mapStateToProps, mapDispatchToProps)(AgencyFeatures);
